import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { getStorage, deleteStorage } from '../modals/Storage';
import { API_ACCESS_URL, API_GET_MYADDRESSES } from "../modals/Constants";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import HeaderView from "../other-components/HeaderView/view";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";

function AllAddresses() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [pageConst, setConstants] = useState({
    showHeadSearch: true,
    toastMessage: "",
    toastDialogShow: false,
    isShowFooter: true,
    isLoadingShow: false,
    addressList: [],
  });

  const updateUIItems = (data) => {
    let tempData = [];

    for (let i = 0; i < data.length; i++) {
      tempData.push(
        <Link key={i} className={screen.item} to={"/update-address?id=" + data[i]['item_id']}>
          <div>
            <h3>{data[i]['item_fullname']}</h3>
            <p>Mobile: {data[i]['item_mobile']}</p>
            <p>{data[i]['item_address']}</p>
          </div>

          <div className={[general.rowView, general.mgT15px].join(" ")}>
            <button>
              Edit
            </button>

            <p className={[general.rowView, general.colorGreen, general.mgL10px].join(" ")}>
              {data[i]['item_primary'] === 'active' && (
                <>
                  <span class="material-symbols-outlined">
                    check
                  </span>
                  Primary
                </>
              )}
            </p>
          </div>
        </Link>
      )
    };

    setConstants((previousState) => {
      return { ...previousState, addressList: tempData };
    });
  };

  const removeAddress = (addressId) => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'route': 'route-remove-address',
            // 'AuthToken': generateAuthToken(pageConst.inMobileNum,ip),
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code = "success") {
          setIsDataLoaded(false);
          loadAllAddresses();
        }
      } catch (error) {
        setLoading(false);
      }
    }

    if ((addressId != "")) {
      setLoading(true);
      const formData = { ACCOUNT_ID: getStorage("accountID"), AUTH_SECRET: getStorage("accountSecret"), ADDRESS_ID: addressId };
      requestAPI(API_ACCESS_URL, formData);
    }
  }

  function loadAllAddresses() {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code == "success") {
          updateUIItems(data.data);
        } else if (data.account_status == "inactive") {
          navigate("/account-update-required", { replace: true });
        } else if (data.account_status == "unauthorized") {
          if (deleteStorage()) {
            navigate("/signin", { replace: true });
          }
        }
      } catch (error) {
        setLoading(false);
      }
    };

    if ((!isDataLoaded)) {
      setLoading(true);
      setIsDataLoaded(true);

      const formData = { ACCOUNT_ID: getStorage("accountID") };
      requestAPI(API_GET_MYADDRESSES, formData);
    }
  }

  useEffect(() => {
    if (getStorage("accountID") == '' || getStorage("accountSecret") == '') {
      navigate('/signin', { replace: true });
    } else {
      loadAllAddresses();
    }
  }, []);

  return (
    <div className={[general.appView]}>
      <LoadingDialog isOpen={loading} />

      <div className={[general.appChildView]}>
        <HeaderView />

        <div className={general.appLocationViews}>
          <p>My Addresses</p>
        </div>

        <div className={[general.appContentsView]}>
          <div className={[screen.addressView, general.mgB100px].join(" ")}>
            <Link className={screen.item} to={"/add-address"}>
              <div>
                <h3>Add New Address</h3>
                <p>Make sure your details are correct.</p>
              </div>

              <button className={general.mgT15px}>
                Add
              </button>
            </Link>

            {pageConst.addressList}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllAddresses;
